import React, { useState } from "react";
import { Card } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ButtonLoading, FormInput } from "go-form";
import useFlash from "go-alert/AlertMessage";
import handleError from "go-app/services/errors";
import { FormDirty } from "go-form/components/FormDirty";
import { apiOrganization } from "../../../../../../../../../services/Api/Organization/apiOrganization";
import { ApplicationApi } from "../../../../../../../../../services/Api/Organization/types";
import { AppState } from "../../../utils/types";
import { parseApplicationSettings, parseApplicationSettingsValues } from "../../../utils/utils";

interface Props {
	appState: AppState;
	handleUpdateApp(app: ApplicationApi): void;
}

const HardRockCafeFormModalCard = ({ appState, handleUpdateApp }: Props) => {
	const { t } = useTranslation();
	const form = useForm<ApplicationApi>({
		criteriaMode: "all",
		defaultValues: {
			...appState.app,
			settings: {
				...appState.app.settings,
				...parseApplicationSettingsValues(appState.app.settings || {}),
			},
		},
	});
	const {
		register,
		handleSubmit,
		formState: { errors },
		formState,
		setError,
		reset,
		watch,
	} = form;
	const [loading, setLoading] = useState(false);
	const { addSuccessFlash, addFlash } = useFlash();

	const onSubmit = handleSubmit(async (data: ApplicationApi) => {
		setLoading(true);
		const params: Record<string, any> = { include: "settings" };

		const settings = parseApplicationSettings(data.settings);
		const newData = {
			name: data.name,
			id: appState.app.id,
			settings,
		};

		try {
			const res = await apiOrganization.updateApp(newData, params);
			handleUpdateApp(res);
			addSuccessFlash(t("lib:common.flash.saved"));
			reset(watch());
		} catch (err) {
			handleError.form(err, setError, addFlash);
		}
		setLoading(false);
	});

	return (
		<Card>
			<Card.Body>
				<FormDirty formState={formState} onSubmit={onSubmit} className="hotellion-app-form">
					<FormInput
						name="settings.terminal_id"
						errors={errors}
						register={register}
						label={t("modules.app.field.terminal_id.title")}
						disabled
					/>
					<FormInput
						name="settings.location_id"
						errors={errors}
						register={register}
						label={t("modules.app.field.location_id.title")}
						disabled
					/>
					<FormInput
						name="settings.security_guid"
						errors={errors}
						register={register}
						label={t("modules.app.field.security_guid.title")}
						disabled
					/>
					<ButtonLoading loading={loading} variant="add" onClick={onSubmit}>
						{t("common.action.save", { ns: "lib" })}
					</ButtonLoading>
				</FormDirty>
			</Card.Body>
		</Card>
	);
};

export default HardRockCafeFormModalCard;
